export const routes = {
  GiftingAccountDashboard: '/gifting/account',
  GiftingAccountRecipientBankPage: '/gifting/account/:planId/:giftingId/bank',
  GiftingAccountRecipientContainer: '/gifting/account/:planId/:giftingId',
  GiftingAccountRecipientOccasionPage:
    '/gifting/account/:planId/:giftingId/occasion',
  GiftingAccountRecipientReviewPage:
    '/gifting/account/:planId/:giftingId/review',
  GiftingAccountRecipientStartPage: '/gifting/account/:planId/:giftingId/start',
  GiftingAccountRecipientSuccessPage:
    '/gifting/account/:planId/:giftingId/success',
  GiftingDashboard: '/gifting',
  GiftingMaintenancePage: '/gifting/maintenance',
  GiftingPasswordPage: '/gifting/:planId/:giftingId/password',
  GiftingPublicBankPage: '/gifting/:planId/:giftingId/bank',
  GiftingPublicInfoPage: '/gifting/:planId/:giftingId/info',
  GiftingPublicLanding: '/gifting/:planId/:giftingId',
  GiftingPublicOccasionPage: '/gifting/:planId/:giftingId/occasion',
  GiftingPublicStartPage: '/gifting/:planId/:giftingId/start',
  GiftingRedirect: '/gifting/index.html',
  GiftingReviewPage: '/gifting/:planId/:giftingId/review',
  GiftingSuccessPage: '/gifting/:planId/:giftingId/success',
  LOGIN_VERIFICATION: '/auth/api/v1/login/verification'
};
